<template>
    <main>
        <section class="intro">
            <div class="title">
                <h1>{{ copydeck.page_privacy.title[lang]}}</h1>
                <figure><img src="https://lesaffranchis.s3.amazonaws.com/images/1698070056-IMG_intro.JPG" data-copydeck="gift_card_images.intro_heading" alt=""></figure>

            </div>
        </section>

        <section class="detail">
            <div class="inner">

                <div class="grey-box">

                    <div v-html="copydeck.page_privacy.text_intro[lang]">

                    </div>
                </div>

            </div>

            <div class="spacer"></div>
        </section>


    </main>
</template>

<script>
export default {
    name: "Introduction",

    created() {
        // parent.debouncedResize;
    }
}
</script>

<script setup>


    import {useMainStore} from "../stores/main";
    import { storeToRefs }          from "pinia";

    let store = useMainStore();
    let { copydeck, lang } = storeToRefs(store);


</script>
